// extracted by mini-css-extract-plugin
export var centerText = "_ei-8";
export var container = "_ei-0";
export var doughnutContainer = "_ei-7";
export var legend = "_ei-a";
export var legendItemColorDisplay = "_ei-b";
export var legendItemLabel = "_ei-d";
export var legendItemValue = "_ei-c";
export var lg = "_ei-5";
export var maxWidth = "_ei-9";
export var md = "_ei-4";
export var responsive = "_ei-6";
export var sm = "_ei-3";
export var xs = "_ei-2";
export var xxs = "_ei-1";